import type { OtPurpose } from "../../../types";

import type { Builder } from "./Builder";

export class OtPurposeBuilder implements Builder<OtPurpose> {
  _body: OtPurpose = {
    id: "78f09e99-2d4d-4ef5-a192-1433f3c47d8c",
    name: "Privacy Policy and Personal Data gathering_DEMO",
    description: "I have read the privacy policy and consent to the processing of personal data",
    language: "en-us",
    mandatory: false,
    default: false,
    section: {
      id: "123",
      name: "Section name",
      description: null,
    },
  };

  constructor(body: Partial<OtPurpose> = {}) {
    this._body = { ...this._body, ...body };
  }

  setId(value: OtPurpose["id"]): this {
    this._body.id = value;
    return this;
  }

  setName(value: OtPurpose["name"]): this {
    this._body.name = value;
    return this;
  }

  setDescription(value: OtPurpose["description"]): this {
    this._body.description = value;
    return this;
  }

  setLanguage(value: OtPurpose["language"]): this {
    this._body.language = value;
    return this;
  }

  setMandatory(value: OtPurpose["mandatory"]): this {
    this._body.mandatory = value;
    return this;
  }
  setDefault(value: OtPurpose["default"]): this {
    this._body.default = value;
    return this;
  }

  setSection(value: OtPurpose["section"]): this {
    this._body.section = value;
    return this;
  }

  setCreatedAt(value: OtPurpose["created_at"]): this {
    this._body.created_at = value;
    return this;
  }

  setRevokesAt(value: OtPurpose["revokes_at"]): this {
    this._body.revokes_at = value;
    return this;
  }

  build(): OtPurpose {
    return this._body;
  }
}
